export default __webpack_public_path__ + "static/media/demand-management.c5f08244.mp4";